import { darken, readableColor } from 'polished';
import { CSSProperties, PropsWithChildren } from 'react';

interface Props {
  readonly bgColor: string;
  readonly bordered?: boolean;
  readonly style?: CSSProperties;
}

export function EditorChunkLabelWrapper(p: PropsWithChildren<Props>) {
  return (
    <div
      style={{
        color: readableColor(p.bgColor),
        textOverflow: 'ellipsis',
        border: p.bordered ? '2px solid ' + darken(0.2, p.bgColor) : undefined,
        background: p.bgColor,
        borderRadius: 4,
        height: '12px !important',
        fontSize: '14px',
        padding: '2px 8px',
        ...(p.style || {}),
      }}
    >
      {p.children}
    </div>
  );
}
